// ---------------------------------------------------------------------
//  @ Role Permissions Actions
// ---------------------------------------------------------------------

import { createAction, props } from '@ngrx/store';
import {
    RolePermissionAssignment,
    RolePermissionRequest,
} from './role-permissions.models';

// Load all role permissions
export const loadRolePermissions = createAction(
    '[Role Permissions] Load Role Permissions'
);
export const loadRolePermissionsSuccess = createAction(
    '[Role Permissions] Load Role Permissions Success',
    props<{ rolePermissions: RolePermissionAssignment[] }>()
);
export const loadRolePermissionsFailure = createAction(
    '[Role Permissions] Load Role Permissions Failure',
    props<{ error: string }>()
);

// Load by role
export const loadRolePermissionsByRole = createAction(
    '[Role Permissions] Load By Role',
    props<{ role: string }>()
);

// Create role permission
export const createRolePermission = createAction(
    '[Role Permissions] Create Role Permission',
    props<{ permission: RolePermissionRequest }>()
);
export const createRolePermissionSuccess = createAction(
    '[Role Permissions] Create Role Permission Success',
    props<{ rolePermission: RolePermissionAssignment; success: string }>()
);
export const createRolePermissionFailure = createAction(
    '[Role Permissions] Create Role Permission Failure',
    props<{ error: string }>()
);

// Bulk create
export const bulkCreateRolePermissions = createAction(
    '[Role Permissions] Bulk Create',
    props<{ permissions: RolePermissionRequest[] }>()
);
export const bulkCreateRolePermissionsSuccess = createAction(
    '[Role Permissions] Bulk Create Success',
    props<{
        rolePermissions: RolePermissionAssignment[];
        success: string;
    }>()
);
export const bulkCreateRolePermissionsFailure = createAction(
    '[Role Permissions] Bulk Create Failure',
    props<{ error: string }>()
);

// Update role permission
export const updateRolePermission = createAction(
    '[Role Permissions] Update Role Permission',
    props<{ id: number; permission: Partial<RolePermissionRequest> }>()
);
export const updateRolePermissionSuccess = createAction(
    '[Role Permissions] Update Role Permission Success',
    props<{ rolePermission: RolePermissionAssignment; success: string }>()
);
export const updateRolePermissionFailure = createAction(
    '[Role Permissions] Update Role Permission Failure',
    props<{ error: string }>()
);

// Delete role permission
export const deleteRolePermission = createAction(
    '[Role Permissions] Delete Role Permission',
    props<{ id: number }>()
);
export const deleteRolePermissionSuccess = createAction(
    '[Role Permissions] Delete Role Permission Success',
    props<{ id: number; success: string }>()
);
export const deleteRolePermissionFailure = createAction(
    '[Role Permissions] Delete Role Permission Failure',
    props<{ error: string }>()
);

// Bulk delete
export const bulkDeleteRolePermissions = createAction(
    '[Role Permissions] Bulk Delete',
    props<{ ids: number[] }>()
);
export const bulkDeleteRolePermissionsSuccess = createAction(
    '[Role Permissions] Bulk Delete Success',
    props<{ ids: number[]; success: string }>()
);
export const bulkDeleteRolePermissionsFailure = createAction(
    '[Role Permissions] Bulk Delete Failure',
    props<{ error: string }>()
);
